import {FC} from "react";
import {useTranslation} from "react-i18next";
import {UserClimbingEvent} from "../../../models/UserClimbingEvent";
import {ClimbingEvent} from "../../../models/ClimbingEvent";
import {FormControl, InputLabel, MenuItem, Select, TextField} from "@mui/material";


type Props = {
  userClimbingEvent: UserClimbingEvent,
  handleBestRouteChange: (routeId: number) => void,
  climbingEvent : ClimbingEvent,
  handleNrOfClimbsOnHardestChange: (nr: number) => void,
  handleNrOfEntryChange: (nr: number) => void,
}

export const PickBestRoute: FC<Props> = ({userClimbingEvent,handleBestRouteChange,climbingEvent, handleNrOfClimbsOnHardestChange,handleNrOfEntryChange}) => {
  const {t} = useTranslation();

  return (

      <FormControl fullWidth>
     {/*   <InputLabel sx={{fontWeight:600}} id="pick-best-route-label">{t('event.bestRoute')}</InputLabel>*/}
     {/*   <Select*/}
     {/*   value={userClimbingEvent.bestRouteId}*/}
     {/*   variant="standard"*/}
     {/*   labelId="pick-best-route-label"*/}
     {/*   onChange={(e) => handleBestRouteChange(e.target.value as number)}*/}
     {/*   >*/}
     {/*   {climbingEvent.routes.map(route => <MenuItem key={route.id} value={route.id}>{route.id}</MenuItem>)}*/}
     {/*</Select>*/}

     {climbingEvent.collectHardest && (
         <>
             <TextField
                 sx={{mt:2}}
                 label={'ilość wejść na bulderownię'}
                 type="number"
                 inputProps={{ min: 0 }}
                 value={userClimbingEvent.nrOfEntry ?? 0}
                 onChange={(e) => {
                     const val = parseInt(e.target.value, 10)
                     const nr = Number.isNaN(val) ? 0 : Math.max(0, val)
                     handleNrOfEntryChange(nr)
                 }}
             />
             <TextField
                 sx={{mt:2}}
                 label={'najwięcej wstawek w jednego balda'}
                 type="number"
                 inputProps={{ min: 0 }}
                 value={userClimbingEvent.nrOfClimbsOnHardest ?? 0}
                 onChange={(e) => {
                     const val = parseInt(e.target.value, 10)
                     const nr = Number.isNaN(val) ? 0 : Math.max(0, val)
                     handleNrOfClimbsOnHardestChange && handleNrOfClimbsOnHardestChange(nr)
                 }}
             />
         </>

     )}

      </FormControl>
     )
}